var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"send-voice-tip"},[_vm._v("\n    开启后，客户可在移动端网页咨询窗口发送短语音消息\n    "),_c('div',{staticClass:"send-voice-tip-img"})])}]

export { render, staticRenderFns }